import { Layers, ChevronRight } from 'react-feather'
import { FormattedMessage } from 'react-intl'

export default [
    {
        id: 'jbfFeed',
        title: <FormattedMessage id='JBF FEED' />,
        icon: <Layers />,

        children: [
            {
                id: 'aquaticFeed',
                title: <FormattedMessage id='Aquatic Feed' />,
                icon: <ChevronRight />,
                navLink: '/jbfAquatic'
            },

            {
                id: 'cattleFeed',
                title: <FormattedMessage id='Cattle Feed' />,
                icon: <ChevronRight />,
                navLink: '/jbfCattle'
            },

            {
                id: 'cricketFeed',
                title: <FormattedMessage id='Cricket Feed' />,
                icon: <ChevronRight />,
                navLink: '/jbfCricket'
            },

            {
                id: 'poultryFeed',
                title: <FormattedMessage id='Poultry Feed' />,
                icon: <ChevronRight />,
                navLink: '/jbfPoultry'
            },

            {
                id: 'swineFeed',
                title: <FormattedMessage id='Swine Feed' />,
                icon: <ChevronRight />,
                navLink: '/jbfSwine'
            }
        ]
    }
]